<template>
	<div class="team">
		<div class="value_title team_title">
			<p>
				Our talented counselor
			</p>
			<div>
				Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut
				labore.
			</div>
		</div>
		<div class="team_list">
			<div class="team_box" v-for="(item,index) in memberList" :key="index">
				<div class="team_box_img">
					<el-image class="team_box_img" style="width: 100%; height: 260px" :src="item.avatar">
						<template v-slot:error>
							<div class="image-slot"
								style="position: absolute;top: 50%;transform: translateX(-50%);left: 48%;transform: translateY(-50%);">
								<i class="el-icon-picture-outline"></i>
							</div>
						</template>
					</el-image>
				</div>
				<div class="team_box_msg">
					<div class="team_box_name">
						{{item.userName}}
					</div>
					<div class="team_box_job">
						{{item.userPosition}}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'TeamPage',
		data() {
			return {
				memberList: [],
			}
		},
		methods: {
			getTeam() {
				this.$api.news.getMember().then((res) => {
					this.memberList = res.data.data
					let userLanguage = localStorage.getItem('userLanguage')
					this.memberList.forEach((item) => {
						if (userLanguage == 'en') {
							item.userName = item.name_en
							item.userPosition = item.position_en
							item.bio = item.bio_en
						} else {
							item.userName = item.name_zh
							item.userPosition = item.position_zh
							item.bio = item.bio_zh
						}
					})
				})
			},
		},
		created() {
			this.getTeam()
		}
	}
</script>

<style scoped>
	.team {
		width: 90%;
		display: flex;
		justify-content: space-between;
	}

	.team_title {
		width: 35%;
		text-align: left;
		margin: 0;
		margin-top: 40px;
	}

	.team_list {
		width: 60%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.team_list .team_box {
		width: 30%;
		height: 350px;
		opacity: 1;
		border-radius: 20px;
		background: rgba(224, 228, 252, 1);
		margin-bottom: 25px;
	}

	.team_box_img {
		width: 100%;
		height: 240px;
		opacity: 1;
		border-radius: 20px;
	}

	.team_box_msg .team_box_name {
		margin: 34px 0 0 24px;
		font-size: 24px;
		font-weight: 700;
		letter-spacing: 0px;
		line-height: 33.6px;
		color: rgba(29, 33, 48, 1);
	}

	.team_box_msg .team_box_job {
		margin-left: 24px;
		font-size: 16px;
		font-weight: 400;
		letter-spacing: 0px;
		line-height: 24px;
		color: rgba(29, 33, 48, 1);
		text-align: left;
	}

	.value_title {
		margin: 0 auto;
	}

	.value_title p {
		font-size: 48px;
		font-weight: 700;
		letter-spacing: 0px;
		line-height: 57.6px;
		color: rgba(29, 33, 48, 1);
		text-align: center;
		vertical-align: top;
	}

	.image-slot {
		width: 50px;
		height: 50px;
		margin: 0 auto;
		position: absolute;
		top: 25%;
		transform: translateY(50%);
	}
</style>